<template>
    <button type="button" :class="btnClass" @click="showUserRoleModal">
        <FileEarmarkPlusIcon />
        <span class="d-none d-sm-inline">
            {{ i18n('Add New') }}
        </span>
    </button>

    <UserRoleModal :role="role" ref="UserRoleModal" @created="$emit('created', $event)"
        @submit="$emit('submit', $event)" />
</template>
<script>
import UserRoleModal from "@/components/userRole/UserRoleModal.vue";
import FileEarmarkPlusIcon from "@/assets/svg/file-earmark-plus.vue";

export default {
    components: {
        UserRoleModal,
        FileEarmarkPlusIcon,
    },
    data() {
        return {
            formData: {},
        };
    },
    props: {
        btnClass: {
            type: String,
            default: 'btn btn-sm btn-outline-dark',
        },
        role: {
            type: Object,
        },
    },
    emits: [
        'added',
        'created',
        'submit',
    ],
    methods: {
        showUserRoleModal() {
            this.$refs['UserRoleModal'].show();
        },
    }
};
</script>
